const handleRedirect = () => {
	const $redirect = $('.js-redirect');

	$redirect.each(function(index, el) {
		const $this = $(this);

		$this.on('click', function() {
			const target = $this.data('redirect');
			window.open(target);
		});
	});
};

handleRedirect();
